import LunchTogether from '../pages/slack/LunchTogether';

export default {
	LunchTogether: {
		id: 'LunchTogether',
		title: '런치 투게더',
		heading: '런치 투게더',
		path: '/slack/lt',
		component: LunchTogether,
	},
};
